<footer>
    <div class="layout-footer" style="background-color: #002865;">
      <div>
        <a href="https://naltec.com/" tabindex="-1"><img height="60px" width="180px" src="../../../assets/images/Logo_NALTechnologies_white_Primary.svg" alt="" title="" /> </a>
      </div>
      <div>
        <div class="text-muted">Copyright © {{currentYear}} | NAL Technologies</div>
        <div class="text-muted centered" *ngIf="packageVersion && packageHash">Vers: {{packageVersion}}-{{packageHash}}</div>
        <div class="text-muted centered" *ngIf="packageVersion && !packageHash">Vers: {{packageVersion}}</div>
      </div>
      <div>
        <div class="p-d-flex brand-icons">
          <a href="https://www.linkedin.com/company/naltec1" target="_blank" rel="nofollow" title="LinkedIn"><i class="fab fa-linkedin"></i></a>
          <a href="https://x.com/naltec_official" target="_blank" rel="nofollow" title="X"><i class="fab fa-x-twitter"></i></a>
          <a href="https://www.youtube.com/channel/UC97Wwv6MwD78KHCU10U94Fg" target="_blank" rel="nofollow" title="YouTube"><i class="fab fa-youtube"></i></a>
        </div>
      </div>
    </div>
</footer>
